<button nz-button nzType="default" (click)="openDrawer()">Parameter Glossary</button>

<nz-drawer [nzVisible]="glossaryOpen()" nzPlacement="right" nzWidth="min(478px)"
  [nzClosable]="false" (nzOnClose)="closeDrawer()"
  [nzBodyStyle]="bodyStyle">
  <ng-container *nzDrawerContent>
    <div class="parameter-glossary">
      <nz-form-item>
        <nz-form-control>
          <nz-input-wrapper nzAllowClear>
            <input #searchInput type="text" nz-input placeholder="Search"
            [ngModel]="typedParameter()" (ngModelChange)="setTypedParameter($event)" (keydown)="onSearchKeydown($event)" />
            <span nz-icon nzType="search" nzInputSuffix></span>
          </nz-input-wrapper>
        </nz-form-control>
      </nz-form-item>

      @if (typedParameter() == "") {
        <div class="parameter-category-grid">
          @for (category of filteredCategories(); track category) {
            <button nz-button class="parameter-category-card" (click)="filterByCategory(category)">
              {{ category }}
            </button>
          } @empty {
            <div class="empty-hint">No categories</div>
          }
        </div>
      } @else {
        <div class="parameter-category-list">
          @for (category of filteredCategories(); track category) {
            <button nz-button nzSize="small"
              class="parameter-category-chip"
              [class.parameter-category-chip-active]="typedParameter().toLowerCase() === category?.toLowerCase()"
              (click)="filterByCategory(category)">
              {{ category }}
            </button>
          }
        </div>

        <div class="parameter-glossary-body">
          <ul nz-menu nzMode="vertical" nzSelectable class="parameter-list">
            @for (result of searchResults(); track result) {
              <li nz-menu-item [nzSelected]="result === selectedParameter()"
                (click)="setSelectedParameter(result)">
                {{ result }}
              </li>
            } @empty {
              <div class="empty-hint-side">No match</div>
            }
          </ul>

          <div class="parameter-detail">
            <nz-spin [nzSpinning]="parameterDefinition.isLoading()">
              @if (displayedResult().error) {
                <div class="empty-hint">
                  No definition found for "{{ typedParameter() }}".
                  @if (isComputeAdmin()) {
                    <button nz-button nzType="text" nzSize="small" (click)="addDefinition()">
                      <span nz-icon nzType="plus" nzTheme="outline"></span>
                    </button>
                  }
                </div>
              } @else if (displayedResult().def; as def) {
                @if (!hasAnyValue(def)) {
                  <div class="empty-hint">
                    No definition found for "{{ selectedParameter() }}".
                    @if (isComputeAdmin()) {
                      <button nz-button nzType="text" nzSize="small" (click)="editDefinition()">
                        <span nz-icon nzType="edit" nzTheme="outline"></span>
                      </button>
                    }
                  </div>
                } @else {
                  <div class="parameter-definition">
                    <h4 class="parameter-definition-title">{{ def.name }}
                    @if (isComputeAdmin()) {
                      <button nz-button nzType="text" nzSize="small" (click)="editDefinition()">
                        <span nz-icon nzType="edit" nzTheme="outline"></span>
                      </button>
                    }
                    </h4>
                    <nz-divider></nz-divider>
                    <div class="parameter-definition-content">
                      @if (hasValue(def.default)) {
                        <div class="parameter-definition-field">
                          <div class="parameter-definition-label">Default</div>
                          <div class="parameter-definition-value">{{ def.default }}</div>
                        </div>
                      }
                      @if (hasValue(def.explanation)) {
                        <div class="parameter-definition-field">
                          <div class="parameter-definition-label">Explanation</div>
                          <div class="parameter-definition-value">{{ def.explanation }}</div>
                        </div>
                      }
                      @if (hasValue(def.arg_type)) {
                        <div class="parameter-definition-field">
                          <div class="parameter-definition-label">Type</div>
                          <div class="parameter-definition-value">{{ def.arg_type }}</div>
                        </div>
                      }
                      @if (hasValue(def.unit)) {
                        <div class="parameter-definition-field">
                          <div class="parameter-definition-label">Unit</div>
                          <div class="parameter-definition-value">{{ def.unit }}</div>
                        </div>
                      }
                      @if (hasValue(def.notes) && isComputeAdmin()) {
                        <div class="parameter-definition-field">
                          <div class="parameter-definition-label">Notes (for review)</div>
                          <div class="parameter-definition-value">{{ def.notes }}</div>
                        </div>
                      }
                      @if (hasValue(def.category)) {
                        <div class="parameter-definition-field">
                          <div class="parameter-definition-label">
                            Category
                            <button nz-button class="parameter-definition-label-clickable" (click)="filterByCategory(def.category)">{{ def.category }}</button>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              } @else {
                <div class="empty-hint">Type a word in to look it up</div>
              }
            </nz-spin>
          </div>
        </div>
      }
    </div>
  </ng-container>
</nz-drawer>
